import { render } from "./CompanyList.vue?vue&type=template&id=3d0fe6ed&scoped=true"
import script from "./CompanyList.vue?vue&type=script&lang=js"
export * from "./CompanyList.vue?vue&type=script&lang=js"

import "./CompanyList.vue?vue&type=style&index=0&id=3d0fe6ed&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0fe6ed"]])

export default __exports__